<template>
    <Tooltip
        ref="tooltipWishlist"
        :text="tooltipText"
        :whitespace="isMobile ? 'normal' : 'nowrap'"
        :width="isMobile && isInProductListCard ? 150 : 250"
        :custom-left-offset="isInProductListCard ? 44 : 0"
        :timeout="6000"
    />
</template>

<script>
import axios from 'axios'
import Tooltip from '../Tooltip/Tooltip.vue'
import resizeObserver from '@vue/utils/resizeObserver.js'

export default {
    scopeName: 'wishlist',
    components: {
        Tooltip
    },
    mixins: [resizeObserver],
    data() {
        return {
            initiator: null,
            tooltipText: ''
        }
    },
    computed: {
        // it isn't sufficient method - we need to differentiate  where it is used (best possible way for now it is by class)
        isInProductListCard() {
            return !!(
                this.initiator &&
                (this.initiator.classList.contains('wishlist-card') ||
                    this.initiator.closest('.product-slider__list'))
            )
        }
    },
    methods: {
        init(el) {
            this.initiator = el
            this.initiator.addEventListener('click', (event) => {
                event.preventDefault()
                event.stopImmediatePropagation()
                this.OnWishlistButtonClick(el)
            })
        },
        OnWishlistButtonClick(button) {
            this.initiator = button
            const $el = button
            const ADD_URL = $el.dataset.wishlistAdd
            const REMOVE_URL = $el.dataset.wishlistRemove
            const isAdded = $el.classList.contains('wishlist-added')
            const PRODUCT_ID =
                $el.dataset.productId ||
                $el?.form?.['product']?.value ||
                document.getElementById('product_id').value
            const FORM_KEY =
                $el?.form?.['form_key']?.value ||
                document.querySelector('[name="form_key"]').value
            let formData = new FormData()
            formData.append('form_key', FORM_KEY)
            formData.append('product', PRODUCT_ID)

            $el.disabled = true
            axios({
                method: 'POST',
                url: isAdded ? REMOVE_URL : ADD_URL,
                data: formData
            })
                .then((response) => {
                    this.handleWishlistResponse(response.data, isAdded, $el)
                })
                .catch((error) => {
                    console.error(error)
                    const ERROR_MSG =
                        'Wystąpił problem. Spróbuj ponownie później.'
                    window.GoogleAnalyticsUniversal.prototype.errorSend({
                        category: 1,
                        action: ERROR_MSG
                    })
                    window.$apteline.modal.OpenModal({
                        title: ERROR_MSG
                    })
                })
                .finally(() => {
                    $el.disabled = false
                })
        },
        handleWishlistResponse(data, isAdded, htmlElement) {
            if (data.redirect) return (window.location.href = data.redirect)
            if (data.error) {
                console.error(data.error)
                window.GoogleAnalyticsUniversal.prototype.errorSend({
                    category: 1,
                    action: data.error
                })
                window.$apteline.modal.OpenModal({
                    title: data.error
                })
            }
            if (data.success) {
                this.initiator.title = isAdded
                    ? 'Dodaj do ulubionych'
                    : 'Usuń z ulubionych'

                const $buttonText = this.initiator.querySelector(
                    '.link-wishlist__message'
                )
                if ($buttonText) {
                    $buttonText.innerHTML = !isAdded
                        ? 'Dodano do <br>ulubionychgfds'
                        : 'Dodaj do <br>ulubionych'
                }

                this.initiator.classList.toggle('wishlist-added', !isAdded)
                this.triggerTooltip(htmlElement, isAdded)
            }
        },
        triggerTooltip(button, isAdded) {
            if (
                this.$refs.tooltipWishlist &&
                typeof this.$refs.tooltipWishlist.Open === 'function'
            ) {
                this.tooltipText = !isAdded
                    ? 'Dodano do ulubionych'
                    : 'Usunięto z ulubionych'
                this.$nextTick(() => {
                    this.$refs.tooltipWishlist.init(button)
                })
                this.$nextTick(() => {
                    this.$refs.tooltipWishlist.Open()
                })
            }
        }
    },
    render: () => null
}
</script>
